import { Component, Input, OnInit } from '@angular/core';

import { Goal } from './goals/goal';
import { GoalsService } from './goals/goals.service';

@Component({
  selector: 'app-sustainability-goals',
  templateUrl: './sustainability-goals.component.html',
  styleUrls: ['./sustainability-goals.component.css']
})
export class SustainabilityGoalsComponent implements OnInit {

  @Input() onShowPeriod;
  @Input() showBusinessAreas;
  @Input() showRating;
  @Input() onFlexGrid;
  @Input() onEdit;
  
  mockGoals: Goal [];
  goals: Goal [];
  receivedGoal: Goal [];
  selectedGoal;
  
  windowWith;
  cubeHalf: Boolean = false;

  constructor(
    private _goalsService: GoalsService
  ) {}

  getMockGoals(): void {
    this._goalsService.getMockGoals().then(mockGoals => this.mockGoals = mockGoals);
  }

  getGoals(): void {
    this._goalsService.getGoals().then(goals => this.goals = goals);
  }

  onResize(event) {
    this.windowWith = event.target.innerWidth;
    this.cubeSizeCheck();
  }

  cubeSizeCheck() {
    if (this.windowWith > 768) {
      this.cubeHalf = false;
    } else {
      this.cubeHalf = true;
    }
  }

  ngOnInit(): void {
    this.getMockGoals();
    this.getGoals();
  }

  transferDataSuccess($event: any) {
    console.log(this.mockGoals);
    const newGoal: Goal = $event.dragData;
    for (let indx in this.mockGoals) {
        let goal: Goal = this.mockGoals[indx];
    }
    this.mockGoals.unshift(newGoal);
  }

  deleteGoal(goal: Goal): void {
    const index: number = this.mockGoals.indexOf(goal);
    if (index !== -1) {
      this.mockGoals.splice(index, 1);
    }
  }

  selectGoal(goal: Goal): void {
    this.selectedGoal = goal;
  }

  deleteSelected() {
    this.selectedGoal = '';
  }
  
}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/sustainability-goals/sustainability-goals.component.ts